import { render, staticRenderFns } from "./recess-image.global.vue?vue&type=template&id=00b10c82&"
import script from "./recess-image.global.vue?vue&type=script&lang=js&"
export * from "./recess-image.global.vue?vue&type=script&lang=js&"
import style0 from "./recess-image.global.vue?vue&type=style&index=0&id=00b10c82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports